module.exports = __webpack_public_path__ + "img/Inline-Visa.91becf5.svg";